import $ from "jquery"

const POPOVER_SELECTOR = ".trip-special-item-details-popover"
const TRIGGER_SELECTOR = ".trip-special-item-details-trigger"
const WRAPPER_SELECTOR = ".trip-special-item-details-wrapper"

function closeTripSpecialItemPopovers() {
  $(POPOVER_SELECTOR).addClass("d-none")
  $(TRIGGER_SELECTOR).attr("aria-expanded", "false")
}

$(document)
  .off("click.tripSpecialItemDetails", TRIGGER_SELECTOR)
  .on("click.tripSpecialItemDetails", TRIGGER_SELECTOR, function(event) {
    event.preventDefault()
    event.stopPropagation()

    const $trigger = $(this)
    const $popover = $trigger.closest(WRAPPER_SELECTOR).find(POPOVER_SELECTOR).first()
    const shouldOpen = $popover.hasClass("d-none")

    closeTripSpecialItemPopovers()

    if (shouldOpen) {
      $popover.removeClass("d-none")
      $trigger.attr("aria-expanded", "true")
    }
  })
  .off("click.closeTripSpecialItemDetails")
  .on("click.closeTripSpecialItemDetails", function(event) {
    if ($(event.target).closest(WRAPPER_SELECTOR).length) return

    closeTripSpecialItemPopovers()
  })
  .off("keydown.closeTripSpecialItemDetails")
  .on("keydown.closeTripSpecialItemDetails", function(event) {
    if (event.key === "Escape") closeTripSpecialItemPopovers()
  })
  .off("cocoon:after-insert.tripSpecialItemDetails", "#trip_special_items")
  .on("cocoon:after-insert.tripSpecialItemDetails", "#trip_special_items", function(_event, insertedItem) {
    const $insertedItem = $(insertedItem)

    $insertedItem.find(POPOVER_SELECTOR).addBack(POPOVER_SELECTOR).addClass("d-none")
    $insertedItem.find(TRIGGER_SELECTOR).addBack(TRIGGER_SELECTOR).attr("aria-expanded", "false")
  })
